
import React from 'react'
import icon from './svgs/NextSlideIcon.svg'
import { BaseIcon } from './_base'

export const NextSlideIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
